import type { LoggerConfigType } from '@/types/LoggerConfigType';
import type { StickyFieldsType } from '@/types/StickyFieldsType';

export const GenericLoggerConfig: LoggerConfigType = {
  templateId: 'GENERIC',
  templateDescription: 'HAMRS POTA Template',
  toolbarItems: ['TIME', 'FREQUENCY', 'MODE', 'TX_POWER', 'MY_CALLSIGN', 'MY_LOCATION'],
  toolbarPosition: 'TOP',
  panels: ['QSO_MAP'],
  tableColumns: ['qsoDateTime', 'call', 'rstSent', 'rstRcvd', 'state', 'freq', 'band', 'mode', 'qrzcomQsoUploadStatus'],
  dupeCheckFields: ['call', 'mode', 'band', 'qsoDate'],
  stickyFields: [
    "freq",
    "band",
    "myPotaRef",
    "myGridsquare",
    "mode",
    "txPwr",
    "myCnty",
    "myState",
    "operator",
    "stationCallsign",
  ] as unknown as StickyFieldsType[],
  fieldRows: [
    {
      columns: { base: 6 },
      fields: [
        { component: 'TheirCall', columns: { base: 4 } },
        { component: 'RstSent' },
        { component: 'RstReceived' }
      ]
    },
    {
      columns: { base: 2 },
      fields: [
        { component: 'Comments' },
        { component: 'Notes' },
      ]
    },
    {
      fields: [
        { component: 'OperatorBar' }
      ]
    },
    {
      classes: "flex justify-end",
      fields: [
        { component: 'ClearButton' },
        { component: 'SaveButton' },
      ]
    }
  ],
}

export default GenericLoggerConfig;